(function ($) {
  $(function () {
    var $modules = $('.case-card-carousel');
    if (!$modules.length) return;

    var LG_MIN = 1199;
    var AUTOPLAY_MS = 6000;

    $modules.each(function () {
      var $module = $(this);
      var $track = $module.find('.case-card-carousel__track').first();
      if (!$track.length) return;

      var $items = $track.find('.case-card-carousel__item');
      if (!$items.length) return;

      var $prev = $module.find('.case-card-carousel__control--prev');
      var $next = $module.find('.case-card-carousel__control--next');

      var activeIndex = 0;
      var autoplayTimer = null;
      var isPaused = false;

      $track.attr({ tabindex: 0, role: 'list' });
      $items.attr({ role: 'listitem' });

      function mod(n, m) {
        return ((n % m) + m) % m;
      }

      function clearGridClasses() {
        $items.removeClass('is-left is-centre is-right');
      }

      function setAllVisibleA11y() {
        $items.each(function () {
          this.removeAttribute('aria-current');
          this.setAttribute('aria-hidden', 'false');
        });
      }

      function ensureGridDots() {
        var $existing = $module.find('.slick-dots[data-case-dots="true"]');
        if ($existing.length) return $existing;

        var $dots = $('<ul class="slick-dots" data-case-dots="true" role="tablist"></ul>');
        $track.after($dots);
        return $dots;
      }

      function buildGridDots() {
        var $dots = ensureGridDots();
        $dots.empty();

        for (var i = 0; i < $items.length; i++) {
          $dots.append('<li><button type="button" aria-label="Go to slide ' + (i + 1) + '"></button></li>');
        }

        $dots.off('click.caseDots').on('click.caseDots', 'button', function () {
          activeIndex = $(this).parent().index();
          updateGrid();
          resetAutoplay();
        });
      }

      function updateGridDots() {
        var $dots = $module.find('.slick-dots[data-case-dots="true"]');
        if (!$dots.length) return;

        var centre = mod(activeIndex, $items.length);
        $dots.find('li').removeClass('slick-active');
        $dots.find('li').eq(centre).addClass('slick-active');
      }

      function updateGrid() {
        var total = $items.length;
        if (!total) return;

        clearGridClasses();

        if (total < 3) {
          $module.removeClass('case-card-carousel--grid-hide');
          setAllVisibleA11y();

          if (total === 1) {
            $items.eq(0).addClass('is-centre').attr('aria-current', 'true');
          } else if (total === 2) {
            var centre2 = mod(activeIndex, total);
            var right2 = mod(centre2 + 1, total);
            $items.eq(centre2).addClass('is-centre').attr('aria-current', 'true');
            $items.eq(right2).addClass('is-right');
          } else {
            var centre3 = mod(activeIndex, total);
            var left3 = mod(centre3 - 1, total);
            var right3 = mod(centre3 + 1, total);
            $items.eq(left3).addClass('is-left');
            $items.eq(centre3).addClass('is-centre').attr('aria-current', 'true');
            $items.eq(right3).addClass('is-right');
          }

          updateGridDots();
          return;
        }

        if (total >= 4) $module.addClass('case-card-carousel--grid-hide');
        else $module.removeClass('case-card-carousel--grid-hide');

        var centre = mod(activeIndex, total);
        var left = mod(centre - 1, total);
        var right = mod(centre + 1, total);

        $items.each(function (i) {
          var $it = $(this);
          $it.removeAttr('aria-current');

          if ($module.hasClass('case-card-carousel--grid-hide')) {
            $it.attr('aria-hidden', 'true');
          } else {
            $it.attr('aria-hidden', 'false');
          }

          if (i === left) {
            $it.addClass('is-left').attr('aria-hidden', 'false');
          } else if (i === centre) {
            $it.addClass('is-centre').attr('aria-current', 'true').attr('aria-hidden', 'false');
          } else if (i === right) {
            $it.addClass('is-right').attr('aria-hidden', 'false');
          }
        });

        updateGridDots();
      }

      function enableGridMode() {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('unslick');
        }

        $module.addClass('case-card-carousel--enhanced case-card-carousel--grid');
        $module.removeClass('case-card-carousel--slider');

        buildGridDots();
        updateGrid();
      }

      function enableSliderMode() {
        $module.addClass('case-card-carousel--enhanced case-card-carousel--slider');
        $module.removeClass('case-card-carousel--grid case-card-carousel--grid-hide');
        clearGridClasses();
        setAllVisibleA11y();

        $module.find('.slick-dots[data-case-dots="true"]').remove();

        if ($.fn.slick) {
          if (!$track.hasClass('slick-initialized')) {
            $track.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
              adaptiveHeight: false,
              infinite: true,
              swipe: true,
              accessibility: true
            });

            $track.on('afterChange.caseCarousel', function (e, slick, currentSlide) {
              activeIndex = currentSlide || 0;
            });
          }
        }
      }

      function applyMode() {
        var isLgUp = window.innerWidth >= LG_MIN;
        if (isLgUp) enableGridMode();
        else enableSliderMode();
      }

      function goNext() {
        if (window.innerWidth >= LG_MIN) {
          activeIndex = mod(activeIndex + 1, $items.length);
          updateGrid();
        } else if ($track.hasClass('slick-initialized')) {
          $track.slick('slickNext');
        }
      }

      function goPrev() {
        if (window.innerWidth >= LG_MIN) {
          activeIndex = mod(activeIndex - 1, $items.length);
          updateGrid();
        } else if ($track.hasClass('slick-initialized')) {
          $track.slick('slickPrev');
        }
      }

      function stopAutoplay() {
        isPaused = true;
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (isPaused) return;
        if (autoplayTimer) return;
        autoplayTimer = window.setTimeout(function tick() {
          goNext();
          autoplayTimer = window.setTimeout(tick, AUTOPLAY_MS);
        }, AUTOPLAY_MS);
      }

      function resetAutoplay() {
        stopAutoplay();
        isPaused = false;
        startAutoplay();
      }

      $prev.on('click', function (e) {
        e.preventDefault();
        goPrev();
        resetAutoplay();
      });

      $next.on('click', function (e) {
        e.preventDefault();
        goNext();
        resetAutoplay();
      });

      $track.on('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
          resetAutoplay();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
          resetAutoplay();
        }
      });

      $module.on('mouseenter', function () {
        stopAutoplay();
      });

      $module.on('mouseleave', function () {
        isPaused = false;
        startAutoplay();
      });

      $module.on('focusin', function () {
        stopAutoplay();
      });

      $module.on('focusout', function () {
        window.setTimeout(function () {
          if (!$module.find(':focus').length) {
            isPaused = false;
            startAutoplay();
          }
        }, 0);
      });

      var resizeTimer = null;
      $(window).on('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(applyMode, 150);
      });

      applyMode();
      startAutoplay();
    });
  });
})(jQuery);
